const styles = (theme) => ({
    root: {
        height: "100%",
        width: "100%",
        backgroundColor: "#f0f0f0",
        borderRadius: "25px",
        padding: "20px 20px",
    },
    backLink: {
        color: "red",
        textDecoration: "none",
        fontFamily: "Helvetica, Arial, Sans-Serif",
    },
    caption: {
        marginBottom: "15px",
    },
    boldText: {
        fontWeight: "700",
        fontSize: "100px",
    },
});

export default styles;
